import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";

export const Route = createFileRoute(
  "/app/c/$customerSlug/d/$docTypeSlug/$documentId",
)({
  errorComponent: ({ error }) => <RouteError error={error} />,
  component: () => null,
});
